import { useParams } from 'react-router-dom';

export const useChatId = () => {
  const { id } = useParams<{ id: string }>();
  const isNumber = !isNaN(Number(id));

  if (!isNumber) {
    throw new Error('Invalid chat ID');
  }

  return Number(id);
};
